namespace TabAurous.Inventory {
    export interface RejectionForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        RejectionType: RejectionTypeEditor;
        DepartmentId: CommonDepartmentLookup;
        PartyId: Serenity.ServiceLookupEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: RejectionItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class RejectionForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.Rejection';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RejectionForm.init)  {
                RejectionForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = RejectionTypeEditor;
                var w5 = CommonDepartmentLookup;
                var w6 = s.ServiceLookupEditor;
                var w7 = s.LookupEditor;
                var w8 = s.DecimalEditor;
                var w9 = s.ImageUploadEditor;
                var w10 = RejectionItemsEditor;

                Q.initFormType(RejectionForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'RejectionType', w4,
                    'DepartmentId', w5,
                    'PartyId', w6,
                    'POSCustomerId', w6,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w7,
                    'ExchRate', w8,
                    'UserId', w7,
                    'EmployeeId', w3,
                    'ProductItemImage', w9,
                    'ItemDetails', w10,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w8,
                    'NetWeight', w8,
                    'NetAmount', w8,
                    'Discount', w8,
                    'AdditionalCharges', w8,
                    'GrossAmount', w8,
                    'Remark', w2,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
